/***************** Fix over-scroll issues on anchors due to fixed masthead ******************/

    (function($, window) {
        var adjustAnchor = function() {
            var $anchor = $(':target');
            var mastheadHeight = $('#header-outer').height();
            //console.log('over-scroll firing - %o', $anchor);
            if ($anchor.length > 0) {
                //var scrollTopVal = $anchor.offset().top - mastheadHeight;
                $.smoothScroll({
                  //  scrollElement: $('div.scrollme'),
                  scrollTarget: $anchor,
                  offset: -mastheadHeight
                });

            }

        };

        $(window).on('hashchange load', function() {
            adjustAnchor();
        });

    })(jQuery, window);

/***************** Google Maps ******************/

function indigo_run_map_google_map(element_id,lat,long,map_zoom){
        console.log('element_id: ' + element_id);
        console.log('lat: ' + lat);
        console.log('long: ' + long);
        console.log('map_zoom: ' + map_zoom);
        console.log(templateurl +'/images/map-marker.png');
				var location = new google.maps.LatLng(lat,long);
                //var marker_image = templateurl +'/img/'+type+'-map-marker.png';
                var image = new google.maps.MarkerImage(templateurl +'/assets/images/map-marker.png',
                    // This marker is 20 pixels wide by 32 pixels tall.
                    null,
                    // The origin for this image is 0,0.
                    new google.maps.Point(0,0),
                    // The anchor for this image is the base of the flagpole at 0,32 (from left, from top).
                    new google.maps.Point(23,58)
                );
				var map_options = {
					zoom: map_zoom,
          scrollwheel: false,
					center: location,
					styles: [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#929fa2"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#bdbdbd"
      }
    ]
  },
  {
    "featureType": "landscape.man_made",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#f2f3f4"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#e0e4e4"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#929fa2"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#929fa2"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dadada"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#d6dbdc"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#929fa2"
      }
    ]
  },
  {
    "featureType": "road.highway.controlled_access",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#929fa2"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#929fa2"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#c9c9c9"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#bec5c7"
      }
    ]
  }
],

				}
				map_google_map = new google.maps.Map(document.getElementById(element_id), map_options);
				var marker = new google.maps.Marker({
				position: location,
        icon: image,
				map: map_google_map				});
                // Style the map using map_type var from admin settings
              //  map_google_map.setMapTypeId(google.maps.MapTypeId[map_type]);
			}


/***************** Address Bar Manipulation ******************/

function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');
  for (var i = 0; i < sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] == sParam) {
      return sParameterName[1];
    }
  }
}

function updateParam(param, value) {
  var url = document.URL;
  var re = new RegExp(param + "(.+?)(&|$)", "g");
  var found = url.match(re);
  if (found) { // If filter= found in url
    var newUrl = url.replace(re, param + '=' + value)
  } else { // If not in url then add it
    var newUrl = url + '?filter=' + value;
  }
  //console.log(newUrl)
  history.pushState(null, null, newUrl);
}

function removeParam(param) {
  var url = document.URL;
  var re = new RegExp(param + "(.+?)(&|$)", "g");
  var found = url.match(re);
  if (found) { // If filter= found in url
    var newUrl = url.replace(re, '');
    var newUrl_stripped = newUrl.substring(0, newUrl.length - 1); // Removing trailing question mark
  } else { // If not in url then do nothing to url
    var newUrl_stripped = url;
  }
  history.pushState(null, null, newUrl_stripped);
}
